/**
 * @description 排行榜奖励
 */

import { RewardStatusEnum, RewardTypeEnum } from "@/types/reward";
import { RewardIcon } from "./reward-icon";
import { Button } from "@/components/ui/button";
import { useBalanceFormatter } from "@/hooks/use-balance-formatter";
import { formatDate } from "@/features/reward/utils/time";
import { useTranslations } from "next-intl";
import { useClaimDebounce } from "./use-claim-debounce";

interface RankingRewardProps {
  status: RewardStatusEnum;
  date: string; // 格式如2025-10-01
  amount: number;
  currency: string;
  claimCurrency: string;
  claimAmount: number;
  bonusWagerMultiple?: number;
  calendarAmount?: number;
  onClaim: () => Promise<unknown>;
}
export const RankingReward = (props: RankingRewardProps) => {
  const { status, date, amount, currency, onClaim } = props;
  const { formatCurrencyDetail } = useBalanceFormatter();
  const t = useTranslations('reward');
  const { loading, run } = useClaimDebounce(onClaim);

  const handleClaim = async () => {
    return run();
  };

  if (status !== RewardStatusEnum.CLAIM) {
    return null;
  }
  return (
    <div className="bg-dark-special rounded-lg py-3 pr-3 flex items-center justify-between" style={{ background: 'linear-gradient(to bottom right, #1D3657 0%, #1B2131 65%, #1B2131 100%)', }}>
      <RewardIcon type={RewardTypeEnum.RANKING_REWARD} className="mr-2.5" />
      <div className="flex-1 text-xs font-medium leading-3">
        <div className="text-white">{t('jackpotprize')}({date && formatDate(date)})</div>
        {!!amount && <div className="text-[#FFC600] text-xss mt-3 font-medium">{formatCurrencyDetail(amount)} {currency}</div>}
      </div>
      <Button
        variant="success"
        size='sm'
        className="w-[90px] ml-[10px]"
        disabled={loading}
        loading={loading}
        onClick={handleClaim}>
        {t('claim')}
      </Button>
    </div>
  );
};
